import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { priceBreaksSelector, isOpenRelatedProductsPopup, isLimitedEditionSelector } from '../../../../../redux/product/product.selectors';
import { priceBreaksSelector as relatedProductsPriceBreaksSelector } from '../../../../../redux/related-product-builder-popup/related-product.selectors';
import { TablePriceComponent } from './table-price';
const mapStateToProps = createSelector(priceBreaksSelector, relatedProductsPriceBreaksSelector, isOpenRelatedProductsPopup, isLimitedEditionSelector, (productPriceBreaksProps, relatedProductPriceBreaksProps, isOpenRelatedProductsPopup, isLimitedEdition) => ({
  prices: productPriceBreaksProps.prices,
  relatedPrices: relatedProductPriceBreaksProps.prices,
  isOpenRelatedProductsPopup,
  isLimitedEdition
}));
export const TablePrice = connect(mapStateToProps)(TablePriceComponent);